import { PatientUpdate } from "@/features/patient/manage/components/patient-update";

const PatientManage = () => {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto">
                <h1 className="mb-4 text-2xl font-semibold">Your profile</h1>
                <PatientUpdate />
            </div>
        </div>
    );
};

export default PatientManage;
